import * as z from 'zod';

export const GetTaxSettingsRequest = /*#__PURE__*/ z.object({});
export const GetTaxSettingsResponse = /*#__PURE__*/ z.object({
  taxSettings: z
    .object({
      taxIncludedInItemPrices: z
        .boolean()
        .describe(
          "Whether tax is already included in catalog item prices.\n\nWhen `true`, checkout treats catalog prices as tax-inclusive and doesn't add tax on top. When `false`, tax is calculated and added on top of catalog prices at checkout.\n\nThis is a site-level display flag, shared by all Wix products on the site. It doesn't re-price the catalog — catalog prices are unchanged; it only controls whether checkout treats them as already including tax.\n\nDefault: `false`"
        )
        .optional(),
      _createdDate: z
        .date()
        .describe('Date and time the tax settings were created.')
        .optional()
        .nullable(),
      _updatedDate: z
        .date()
        .describe('Date and time the tax settings were last updated.')
        .optional()
        .nullable(),
    })
    .describe('Retrieved tax settings.')
    .optional(),
});
export const UpsertTaxSettingsRequest = /*#__PURE__*/ z.object({
  taxSettings: z
    .object({
      taxIncludedInItemPrices: z
        .boolean()
        .describe(
          "Whether tax is already included in catalog item prices.\n\nWhen `true`, checkout treats catalog prices as tax-inclusive and doesn't add tax on top. When `false`, tax is calculated and added on top of catalog prices at checkout.\n\nThis is a site-level display flag, shared by all Wix products on the site. It doesn't re-price the catalog — catalog prices are unchanged; it only controls whether checkout treats them as already including tax.\n\nDefault: `false`"
        )
        .optional(),
      _createdDate: z
        .date()
        .describe('Date and time the tax settings were created.')
        .optional()
        .nullable(),
      _updatedDate: z
        .date()
        .describe('Date and time the tax settings were last updated.')
        .optional()
        .nullable(),
    })
    .describe('Tax settings to upsert.'),
});
export const UpsertTaxSettingsResponse = /*#__PURE__*/ z.object({
  taxSettings: z
    .object({
      taxIncludedInItemPrices: z
        .boolean()
        .describe(
          "Whether tax is already included in catalog item prices.\n\nWhen `true`, checkout treats catalog prices as tax-inclusive and doesn't add tax on top. When `false`, tax is calculated and added on top of catalog prices at checkout.\n\nThis is a site-level display flag, shared by all Wix products on the site. It doesn't re-price the catalog — catalog prices are unchanged; it only controls whether checkout treats them as already including tax.\n\nDefault: `false`"
        )
        .optional(),
      _createdDate: z
        .date()
        .describe('Date and time the tax settings were created.')
        .optional()
        .nullable(),
      _updatedDate: z
        .date()
        .describe('Date and time the tax settings were last updated.')
        .optional()
        .nullable(),
    })
    .describe('Created or updated tax settings.')
    .optional(),
});
